import * as React from "react";

const RightArrowLongIcon: React.FC = () => {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7797 4.53005L8.77969 7.53005C8.48648 7.82325 8.01188 7.82278 7.71914 7.53005C7.42617 7.23708 7.42617 6.76247 7.71914 6.4695L9.44062 4.75036H0.75C0.335391 4.75036 0 4.41521 0 3.97927C0 3.54333 0.335391 3.25036 0.75 3.25036H9.44062L7.72078 1.53052C7.42781 1.23755 7.42781 0.762939 7.72078 0.469971C8.01375 0.177002 8.48836 0.177002 8.78133 0.469971L11.7813 3.46997C12.0727 3.76364 12.0727 4.23708 11.7797 4.53005Z" fill="#0F96D9"/>
</svg>

    );
};

export default React.memo(RightArrowLongIcon);
